import React from 'react';
import cn from 'classnames';
import { useHistory } from 'react-router-dom';

import { ReactComponent as Telegram } from '../../../images/DigitalPlatform/telegram.svg';
import { StoreContext } from '../../../store';
import TransitArrow from '../../SVG/TransitArrow';

import style from './Item.module.css';
import { IProduct } from './1MonitoringConstants';

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'id'> {
  id: number;
  // className: string;
  name: string;
  item: IProduct;
}
function ItemDP({ item, name, id, ...props }: Props): JSX.Element {
  const history = useHistory();
  const handleClick = () => {
    history.push(`/product/${item.EnName}`);
  };

  return (
    <div id="#sectionDP" className={style.sectionDP}>
      {/* <div className={style.detailitem__title} style={{ flexDirection: id % 2 == 0 ? 'row-reverse' : 'row' }}>
        <Tag title="Продукты INNERICA" color="grey" />
        <h2>{item.name}</h2>
      </div> */}
      <div className={cn(style.sectionRight, props.className)}>
        <div className={style.cards}>
          <div className={style.card}>
            <div className={style.titlebox}>
              <Telegram />
              <div className={style.title}>{item.name}</div>
            </div>
            <p>{item.text}</p>
          </div>
          <div className={style.card}>
            <div className={style.titlebox}>
              <Telegram />
              <div className={style.title}>Возможности</div>
            </div>
            <ul className={style.list}>
              {item.list.map(el => {
                return <li key={`ItemDP_itemlist__${el}`}>{el}</li>;
              })}
            </ul>
          </div>
          <div className={cn(style.card, style.active)}>
            <div className={style.titlebox}>
              <Telegram />
              <div className={style.title}>Эффекты</div>
            </div>
            <ul className={style.list}>
              {item.effects.map(el => {
                return <li key={`ItemDP_effects__${el}`}>{el}</li>;
              })}
            </ul>
          </div>
        </div>
        <div className={cn(style.img_container, { [style.isHidden]: !item.imgMainPage })}>
          {item.imgMainPage && <img src={item.imgMainPage} alt={item.name} />}
        </div>
        {/* <Link key={index} to={item.to} */}
        <a className={style.btn__more} onClick={handleClick}>
          Узнать больше
          <TransitArrow className={style.arrow} color="white" width={11} height={11} strokeWidth="4" />
        </a>
        {/* <div className={style.btnbox}>
          <Button className={style.btn} onClick={contactUs.open} variant="filled" round>
            Заказать бесплатную демонстрацию
          </Button>
        </div> */}
      </div>
    </div>
  );
}

export default ItemDP;
